export function generateEndedOverlay(player) {
    const localize = player.localize?.bind(player);
    const template =  `<div>
        <a target="_blank">
            <img class="vjs-presentation-ended-image" alt="${localize('Presentation Ended')}" width="520" height="70">
            <div aria-hidden="true" class="vjs-presentation-ended-text">${localize('Presentation Ended')}</div>
        </a>
        <div class="mediasite-player__presentation-ended-replay-holder">
            <button type="button" class="mediasite-player__presentation-ended-replay-button">
                <span aria-hidden="true" class="vjs-icon-replay"></span>
                <span>${localize('Replay')}</span>
            </button>
            <button type="button" class="mediasite-player__presentation-ended-return-button">
                <span aria-hidden="true" class="vjs-icon-previous-item"></span>
                <span>${localize('Back to Previous')}</span>
            </button>
        </div>
    </div>`;

    const element = document.createElement('div');
    element.innerHTML = template;
    return element.firstElementChild;
}